import axios from "axios";
import moment from "moment";
import store from "../../store/index";
import ThresholdPopup from "../ThresholdPopup/ThresholdPopup.vue";
import CriticalDPModal from '../CriticalDPPopup/CriticalDPModal.vue';
export default {
  name: "ractTool",
  components: {
    ThresholdPopup,
    CriticalDPModal
  },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      idtoken: "",
      totalCount: 0,
      pageindex: 1,
      pagesize: 200,
      ConvertTonumeric: true,
      SortProperty: "CategoryId",
      SortOrder: "0",
      ractlist: [],
      getColumns: [],
      currentTemplatePage: 1,
      totalTemplatePages: 1,
      showMoreDescription: {},
      showMoreCategory: {},
      editedRowId: null,
      dropdownOpen: false,
      showFilter: false,
      showTableLoader: false,
      selectedcolumnobj: {},
      selectedColumns: [],
      editableRow: {},
      overallRiskLevel: "Low",
      phase: "",
      typeOfRisk: "",
      typeOfRiskList: [],
      phases: [],
      categoryList: [],
      category: "",
      scoreMap: {
        High: 3,
        Medium: 2,
        Low: 1,
        "Difficult to detect": 3,
        "Medium to detect": 2,
        "Easy to detect": 1,
      },
      createRiskScore: {
        categoryId: "",
        riskName: "",
        studyId: "",
        siteId: "",
        dataScopeId: "",
        dataScope: "",
        probability: "",
        impact: "",
        detectability: "",
        value: "",
        unit: ""
      },
      defaultdate: "",
      studyId: "",
      selectedSiteId: "",
      sites: [],
      showThresholdPopup: false,
      selectedRiskId: "",
      selectedVersion: "",
      showCriticalPopUp: false,
      criticalDataPoints: [],
      averageRisk : 0,
    };
  },
  async mounted() {
    this.idtoken = store.getters.getIdToken;
    this.defaultdate = localStorage.getItem("dateformat");
    this.studyId = store.getters.getStudyIs;

    window.addEventListener("studyIdChanged", (event) => {
      console.log("StudyIDChanged into" + event.detail.storage);
      this.rollsprivilages = store.getters.getRolesprivilegeData;
      this.studyId = event.detail.storage;
      this.getsites();
      this.getRactData();
      this.ListPhase();
      this.ListCategory();
      this.ListTypeOfRisk();
      this.initializeColumns();

    });

    await this.getsites();
    await this.getRactData();
    await this.ListPhase();
    await this.ListCategory();
    await this.ListTypeOfRisk();
    await this.initializeColumns();
  },
  computed: {
    totalRiskScoreSum() {
      return this.ractlist.reduce((sum, item) => {
        return sum + (item.totalCategoryRiskScore || 0);
      }, 0);
    },
    computedRiskLevel() {
      const total = this.totalRiskScoreSum;
      if (total > 20) return "High";
      if (total >= 10) return "Medium";
      return "Low";
    },
    riskStatus() {
      // min and max is 1 to 27 if the risk range is 1 to 3 (for PDI)
      const avg = this.averageRisk;
      const min = 1;
      const max = 27;
      const band = (max - min) / 3;

      if (avg < min + band) return "Low";
      if (avg < min + band * 2) return "Medium";
      return "High";
  }
  },
  methods: {
    initializeColumns() {
      if (this.ractlist.length > 0) {
        const allowedKeys = [
          "categoryId",
          "category",
          "subCategory",
          "dataScope",
          "objectives",
          "riskIndicator",
          "discussionDetails",
          "unit",
          "core",
          "levelOfScrutiny",
          "frequency",
          "thresholdBasis",
          "impactPoint",
          "probabilityPoint",
          "detectabilityPoint",
          "totalCategoryRiskScore",
          "scorecard",
          "weighting",
          "mitigationAction",
          "riskRating",

          "phase",
          "executionType",
          "executionDate",
          "value",
          "typeOfRisk",


        ];
        this.getColumns = Object.keys(this.ractlist[0]).filter((column) =>
          allowedKeys.includes(column)
        );
        const fieldLabels = {
          categoryId: "Category ID",
          category: "Category",
          subCategory: "Sub Category",
          dataScope: "Data Scope",
          objectives: "Objectives",
          riskIndicator: "Risk Indicator",
          discussionDetails: "Discussion Details",
          unit: "Unit",
          core: "Core",
          levelOfScrutiny: "Level of Scrutiny",
          frequency: "Frequency",
          thresholdBasis: "Threshold Basis",
          impactPoint: "Impact",
          probabilityPoint: "Probability",
          detectabilityPoint: "Detectability",
          totalCategoryRiskScore: "Risk Score",
          scorecard: "Score Card",
          weighting: "Weighting",
          mitigationAction: "Mitigation Action",

          riskRating: "Risk Rating",
          phase: "Phase",
          executionType: "Execution Type",
          executionDate: "Execution Date",
          value: "Derived Value",
          typeOfRisk: "Type of Risk",
        };

        const readableData = allowedKeys.map((key) => fieldLabels[key] || key);
        const initiallyTrueKeys = ["Category ID", "Category", "Sub Category", "Data Scope", "Risk Indicator", "Execution Type","Derived Value","Unit", "Impact", "Probability", "Detectability", "Risk Score"];

        this.getColumns = readableData;
        this.selectedColumns = initiallyTrueKeys;
        this.selectedcolumnobj = this.getColumns.reduce((obj, key) => {
          obj[key] = initiallyTrueKeys.includes(key);
          return obj;
        }, {});
        console.log("object", this.selectedColumns);
      }
    },
    async startEdit(item) {
      this.editedRowId = item.id;
      this.editableRow = { ...item };
    },
    async updateScore() {
      const impact = this.scoreMap[this.editableRow.impact] || 0;
      const probability = this.scoreMap[this.editableRow.probability] || 0;
      const detectability = this.scoreMap[this.editableRow.detectability] || 0;

      this.editableRow.totalCategoryRiskScore = impact * probability * detectability;
    },
    cancelEdit() {
      this.editedRowId = null;
      this.editableRow = {};
    },
    deleteRact(id) {
      if (confirm("Are you sure you want to delete this risk assessment?")) {
        axios
          .delete(`${this.baseurl}/forms/rbqm/delete?id=${id}`, {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          })
          .then(() => {
            this.ractlist = this.ractlist.filter((item) => item.id !== id);
            alert("Risk assessment deleted successfully!");
          })
          .catch((error) => {
            console.error("Failed to delete:", error);
          });
      }
    },
    async saveRow(id) {
      // Prepare payload according to API requirements
      const {
        category,
        subCategory,
        dataScope,
        riskIndicator,
        discussionDetails,
        coreOrExtendedKRI,
        generalOrSpecific,
        levelOfScrutiny,
        executionType,
        value,
        frequency,
        thresholdBasis,
        scorecard,
        weighting,
        mitigationActions,
        categoryId,
        phase,
        executionDate,
        typeOfRisk,
        objectives,
        studyId,
        templateId,
      } = this.editableRow;

      // Map risk levels to points
      const impactPoint = this.scoreMap[this.editableRow.impact] || 0;
      const probabilityPoint = this.scoreMap[this.editableRow.probability] || 0;
      const detectabilityPoint = this.scoreMap[this.editableRow.detectability] || 0;

      const payload = {
        id,
        category,
        subCategory,
        dataScope,
        riskIndicator,
        discussionDetails,
        coreOrExtendedKRI,
        generalOrSpecific,
        levelOfScrutiny,
        executionType,
        value,
        frequency,
        thresholdBasis,
        scorecard,
        weighting,
        mitigationActions,
        phase,
        executionDate,
        typeOfRisk,
        objectives,
        studyId,
        templateId,
        impactPoint,
        probabilityPoint,
        detectabilityPoint,
      };

      try {
        await axios.put(`${this.baseurl}/forms/rbqm/update`, payload, {
          headers: {
            Authorization: "Bearer " + this.idtoken,
            "Content-Type": "application/json",
          },
        });

        const index = this.ractlist.findIndex((r) => r.id === id);
        if (index !== -1) {
          this.ractlist[index] = {
            ...this.editableRow,
            impactPoint,
            probabilityPoint,
            detectabilityPoint,
            totalCategoryRiskScore: impactPoint * probabilityPoint * detectabilityPoint,
          };
        }

        this.editedRowId = null;
        this.editableRow = {};
        alert("Row updated successfully!");
      } catch (error) {
        console.error("Failed to update:", error);
      }
    },

    async getRactData() {
      const idtoken = store.getters.getIdToken;
      var DataScopeId = this.selectedSiteId ? this.selectedSiteId : this.studyId;
      this.showTableLoader = true;
      await axios
        .get(
          ` ${this.baseurl}/forms/rbqm/getriskitem?` +
          "StudyId=" +
          this.studyId +
          "&DataScopeId=" +
          DataScopeId +
          "&pageindex=" +
          this.currentTemplatePage +
          "&pagesize=" +
          this.pagesize +
          "&SortProperty=" +
          this.SortProperty +
          "&ConvertToNumeric="+
          this.ConvertTonumeric +
          "&SortOrder=" +
          this.SortOrder + 
          "&DataScope=" + "Study",
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
            // params: {
            //   StudyId: this.studyId || "",
            //   pageindex: this.currentTemplatePage || 1,
            //   pagesize: this.pagesize || 10,
            //   SortProperty: this.SortProperty || "",
            //   SortOrder: this.SortOrder || "asc",
            //   DataScopeId: this.studyId || "",
            //   DataScope: "Study",
            // },
          }
        )
        .then((res) => {
          this.ractlist = res.data.data.entities;
          this.totalCount = res.data.data.totalCount;
          this.totalTemplatePages = Math.ceil(this.totalCount / this.pagesize);
          this.averageRisk = res.data.studyScore || 0;
          // Calculate totalCategoryRiskScore for each item
          const reverseScoreMap = {
            3: "High",
            2: "Medium",
            1: "Low",
          };

          const reverseDetectabilityMap = {
            3: "Difficult to detect",
            2: "Medium to detect",
            1: "Easy to detect",
          };

          this.ractlist.forEach((item) => {
            // Total Score
            item.totalCategoryRiskScore =
              (item.impactPoint || 0) *
              (item.probabilityPoint || 0) *
              (item.detectabilityPoint || 0);

            // Convert point to level (if not already present)
            item.impact = item.impact || reverseScoreMap[item.impactPoint] || "Low";
            item.probability =
              item.probability || reverseScoreMap[item.probabilityPoint] || "Low";
            item.detectability =
              item.detectability ||
              reverseDetectabilityMap[item.detectabilityPoint] || "Easy to detect";
          });
          this.showTableLoader = false;
        })
        .catch((err) => {
          this.showTableLoader = false;
          console.log("error..", err);
        });
    },
    async SearchRACT() {
      const idtoken = store.getters.getIdToken;
      var DataScopeId = this.selectedSiteId ? this.selectedSiteId : this.studyId;
      const queryParams = new URLSearchParams({
        StudyId: this.studyId,
        DataScopeId: DataScopeId,
        pageindex: this.currentTemplatePage,
        pagesize: this.pagesize,
        SortProperty: this.SortProperty,
        ConvertToNumeric: this.ConvertTonumeric,
        SortOrder: this.SortOrder,
        Phase: this.phase,
        TypeOfRisk: this.typeOfRisk,
        Category: this.category,
        DataScope: this.selectedSiteId != "" ? "Site" : "Study",
      });

      try {
        const res = await axios.get(
          `${this.baseurl}/forms/rbqm/getriskitem?${queryParams}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        this.ractlist = res.data.data.entities;
        this.totalCount = res.data.data.totalCount;
        this.totalTemplatePages = Math.ceil(this.totalCount / this.pagesize);

        const reverseScoreMap = {
          3: "High",
          2: "Medium",
          1: "Low",
        };

        const reverseDetectabilityMap = {
          3: "Difficult to detect",
          2: "Medium to detect",
          1: "Easy to detect",
        };

        this.ractlist.forEach((item) => {
          // Total Score
          item.totalCategoryRiskScore =
            (item.impactPoint || 0) *
            (item.probabilityPoint || 0) *
            (item.detectabilityPoint || 0);

          // Convert point to level (if not already present)
          item.impact = item.impact || reverseScoreMap[item.impactPoint] || "Low";
          item.probability =
            item.probability || reverseScoreMap[item.probabilityPoint] || "Low";
          item.detectability =
            item.detectability ||
            reverseDetectabilityMap[item.detectabilityPoint] || "Easy to detect";
        });
        this.showTableLoader = false;

      } catch (err) {
        console.error("Search error:", err);
      }
    },
    async CreateRiskScore(item) {
      this.createRiskScore = {
        categoryId: item.categoryId,
        riskName: item.riskIndicator,
        studyId: item.studyId,
        siteId: item.siteId,
        dataScope : item.dataScope == null ? "Study" :  item.dataScope,
        dataScopeId: item.dataScopeId == null ? item.studyId : item.dataScopeId,
        probability: this.scoreMap[this.editableRow.probability],
        impact: this.scoreMap[this.editableRow.impact],
        detectability: this.scoreMap[this.editableRow.detectability],
        value: "",
        unit: ""
      }
      const idtoken = store.getters.getIdToken;
      await axios.post(`${this.baseurl}/forms/rbqm/createriskscore`, this.createRiskScore,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }).then((res) => {
          console.log("Risk score created successfully:", res.data);
          this.editedRowId = null;
          this.getRactData();
        }).catch((error) => {
          console.error("Error creating risk score:", error);
          alert("Failed to create risk score. Please try again.");
        });
    },
    async ListPhase() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(
          `${this.baseurl}/forms/rbqm/distintfieldvalues?fieldname=phase`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.phases = response.data;
        console.log("Phases fetched successfully:", this.phases);
      } catch (error) {
        console.error("Error fetching phases:", error);
        return [];
      }
    },
    async ListTypeOfRisk() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(
          `${this.baseurl}/forms/rbqm/distintfieldvalues?fieldname=typeOfRisk`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.typeOfRiskList = response.data;
        console.log("Type of Risk fetched successfully:", this.typeOfRiskList);
      } catch (error) {
        console.error("Error fetching Type of Risk:", error);
        this.typeOfRiskList = [];
      }
    },
    async ListCategory() {
      const idtoken = store.getters.getIdToken;
      try {
        const response = await axios.get(
          `${this.baseurl}/forms/rbqm/distintfieldvalues?fieldname=category`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        this.categoryList = response.data;
        console.log("Category fetched successfully:", this.categoryList);
      } catch (error) {
        console.error("Error fetching Category:", error);
        this.categoryList = [];
      }
    },
    async getsites() {
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      await axios
        .get(`${this.baseurl}/management/site/getallsitesbyuser?studyId=${currentstudy}&getAll=false`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          this.sites = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    LoadData: function (page) {
      this.currentTemplatePage = page;
      this.getRactData();
    },
    filter(data) {
      if (data) {
        return moment(data).format(this.defaultdate)
      }
    },
    showCriticalDP(risk) {
      this.selectedRiskId = risk.categoryId;
      this.selectedVersion = risk.version;
      this.showThresholdPopup = true;
    },
    async openCriticalDP(risk) {
      if(risk.executionType=="Manual") {
      await this.getCriticaldataPoints("Default", 1);
      }
      else {
          await this.getCriticaldataPoints(risk.categoryId, risk.version);
      }
      await this.openCriticalPopup();

    },
    async getCriticaldataPoints(categoryId, version) {
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      try {
        var res = await axios.get(`${this.baseurl}/forms/rbqm/getcriticaldatapoints?studyId=${currentstudy}&riskId=${categoryId}&version=${version}&isActive=true`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Critical Data Points:", res.data);
        this.criticalDataPoints = res.data.entities;
      } catch (error) {
        console.error("Error fetching critical data points:", error);
      }
    },
    async openCriticalPopup() {
      this.showCriticalPopUp = true;
    },
    async closeCriticalDataPopup() {
      this.criticalDataPoints = [];
      this.showCriticalPopUp = false;
    },
  },
};